import { createContext, useContext } from "react";

export interface AccordionContextType {
  checkIfActive: (title: string) => boolean;
  onToggle: (title: string) => void;
}

export const AccordionContext = createContext<AccordionContextType | null>(
  null,
);

AccordionContext.displayName = "AccordionContext";

export const useAccordionContext = () => {
  const context = useContext(AccordionContext);
  if (!context) {
    throw new Error(
      "useAccordionContext must be used within an AccordionContext.Provider",
    );
  }
  return context;
};
